import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import IndexHarmonizationReportPresenter, {
  IIndexHarmonizationReportPresenter,
} from "../presenter/IndexHarmonizationReportPresenter";

export default class ShowIndexHarmonizationReportInteractor {
  private application: Application;
  private output?: IIndexHarmonizationReportPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;

  constructor({ application, getAllOrganisations }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
  }

  private async getOrganisations() {
    return this.getAllOrganisations.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getOrganisations()]);
  }

  execute() {
    this.output = IndexHarmonizationReportPresenter({
      application: this.application,
      initialState: {
        mainOrganisationId: NaN,
        selectedCategoryId: NaN,
        organisationIds: [],
        organisations: [],
        organisationIndexCategories: [],
        dateIncluded: undefined,
        data: [],
      },
    });
    this.getReferenceLists().then(([organisations]) => {
      this.output?.loadReferenceValues(organisations);
    });
    return this.output;
  }
}
